module.exports = __webpack_public_path__ + "static/media/Dossier_de_presse.60dff9f6.pdf";